var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3" },
    [
      _c("div", { staticClass: "panel-tag mt-2" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.__t("WOLT_LOCATION_PARAMS")) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "choose_type pb-4" },
        [
          _c("yes_no", {
            key: "WOLT_TYPE",
            attrs: { radio_options: _vm.radio_options, title: "WOLT_TYPE" },
            model: {
              value: _vm.location.general_fields.type,
              callback: function ($$v) {
                _vm.$set(_vm.location.general_fields, "type", $$v)
              },
              expression: "location.general_fields.type",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.general_fields, function (general_field) {
        return _c(
          "div",
          { key: general_field.key, staticClass: "form-group mt-2" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.get_wolt_param_name(general_field.title)) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0, true),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.general_fields[general_field.key],
                    expression: "location.general_fields[general_field.key]",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: general_field.key, type: "text" },
                domProps: {
                  value: _vm.location.general_fields[general_field.key],
                },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.location.general_fields,
                      general_field.key,
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }